import { styled, Box } from '@mui/material';

export default styled(Box)({
  padding: '24px',
  marginLeft: 'auto',
  marginRight: 'auto',
  '@media(min-width: 423px)': {
    maxWidth: '423px',
    width: '423px',
  },
});
